module.exports = __webpack_public_path__ + "img/orders.19cfd1e2.png";